var React = require('react');

function Adressepostale (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n"),React.createElement("g",{"key":1},[React.createElement("polyline",{"className":"st0","points":"40.5,24.9 40.5,41.2 16.2,41.2 16.2,25.1 \t","key":0}),React.createElement("g",{"key":1},React.createElement("polyline",{"className":"st0","points":"43.2,27 28.3,15.5 13.5,27 \t\t"})),React.createElement("path",{"className":"st0","d":"M24.7,41.2v-9.8c0-2,1.6-3.6,3.6-3.6h0c2,0,3.6,1.6,3.6,3.6v9.8","key":2})])]);
}

Adressepostale.defaultProps = {"version":"1.1","id":"Calque_1","x":"0px","y":"0px","viewBox":"0 0 56.7 56.7","style":{"enableBackground":"new 0 0 56.7 56.7"},"xmlSpace":"preserve"};

module.exports = Adressepostale;

Adressepostale.default = Adressepostale;
